import HelmetManager from './HelmetManager'

export default HelmetManager


// WEBPACK FOOTER //
// ./src/components/HelmetManager/index.js